import Axios from "axios";
import { SET_INV_GATEPASS_REPORT, UNSET_INV_GATEPASS_REPORT } from "@/store/mutation-types";
import { getInvGatepassReport } from "@/store/api";

const state = { getInvGatepassReport: {} };

const getters = {
  getInvGatepassReport(state) {
    return state.getInvGatepassReport;
  },
};

const mutations = {
  [SET_INV_GATEPASS_REPORT](state, data) {
    state.getInvGatepassReport = data;
  },
  [UNSET_INV_GATEPASS_REPORT](state) {
    state.getInvGatepassReport = {};
  },
};

const actions = {
  getInvGatepassReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getInvGatepassReport, { params: data })
        .then(function (response) {
          commit("SET_INV_GATEPASS_REPORT", response.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_INV_GATEPASS_REPORT");
          reject(error);
        })
        .then((always) => {});
    });
  },
};

export default { state, getters, actions, mutations };
